export const B2B_REGISTRATION_INTL = {
  error: {
    duplicate: {
      id: 'b2b.registration.error.duplicate',
      defaultMessage: 'This phone number is already registered for this event.',
    },
    rateLimit: {
      id: 'b2b.registration.error.rateLimit',
      defaultMessage: 'Too many requests. Please wait a moment and try again.',
    },
    network: {
      id: 'b2b.registration.error.network',
      defaultMessage: 'We couldn’t reach the server. Check your connection and try again.',
    },
    generic: {
      id: 'b2b.registration.error.generic',
      defaultMessage: 'Something went wrong. Please try again later.',
    },
  },
  success: {
    title: {
      id: 'b2b.registration.success.title',
      defaultMessage: 'We’ve got your request',
    },
    description: {
      id: 'b2b.registration.success.description',
      defaultMessage:
        "We'll review your request as an event organizer and get back to you within 3–5 business days.",
    },
  },
  field: {
    required: {
      id: 'b2b.registration.field.required',
      defaultMessage: 'This field is required.',
    },
    invalid: {
      id: 'b2b.registration.field.invalid',
      defaultMessage: 'Please check this field and try again.',
    },
  },
} as const;

export type B2bRegistrationErrorDescriptor =
  (typeof B2B_REGISTRATION_INTL.error)[keyof typeof B2B_REGISTRATION_INTL.error];

export const b2bRegistrationErrorDescriptorForHttpStatus = (
  status: number,
): B2bRegistrationErrorDescriptor => {
  if (status === 409) return B2B_REGISTRATION_INTL.error.duplicate;
  if (status === 429) return B2B_REGISTRATION_INTL.error.rateLimit;
  return B2B_REGISTRATION_INTL.error.generic;
};
